import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "apnicare_cart";
export const FREE_DELIVERY_ABOVE = 499;
export const DELIVERY_FEE = 49;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } });
  const [open, setOpen] = useState(false);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => setItems((c) => { const i = c.findIndex((x) => x.id === p.id); if (i >= 0) { const n = [...c]; n[i] = { ...n[i], qty: Math.min(20, n[i].qty + qty) }; return n; } return [...c, { id: p.id, name: p.name, price: p.price, mrp: p.mrp, image: p.image, qty }]; });
  const setQty = (id, qty) => setItems((c) => qty <= 0 ? c.filter((x) => x.id !== id) : c.map((x) => (x.id === id ? { ...x, qty: Math.min(20, qty) } : x)));
  const remove = (id) => setItems((c) => c.filter((x) => x.id !== id));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, x) => s + x.price * x.qty, 0);
    const savings = items.reduce((s, x) => s + Math.max(0, (x.mrp || x.price) - x.price) * x.qty, 0);
    const delivery = subtotal === 0 || subtotal >= FREE_DELIVERY_ABOVE ? 0 : DELIVERY_FEE;
    return { subtotal, savings, delivery, total: subtotal + delivery, count: items.reduce((s, x) => s + x.qty, 0) };
  }, [items]);

  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, totals, open, setOpen }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
